"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.WILDCARD_ID = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _Asset = _interopRequireDefault(require("./Asset"));

var _getExemptionRules = _interopRequireDefault(require("./getExemptionRules"));

var _errors = require("../errors/errors");

var _Exemption = _interopRequireDefault(require("./Exemption"));

var _subTypes = require("../assets/subTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var WILDCARD_ID = -1;
exports.WILDCARD_ID = WILDCARD_ID;

var Rule =
/*#__PURE__*/
function () {
  function Rule(id, lawName, limitAggregateSingle, limitAggregateJoint, limitAggregate, limitPerItem, assetLimit, canApply) {
    var transformFromContext = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
    var requiresReview = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;
    var description = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : '';

    _classCallCheck(this, Rule);

    _defineProperty(this, "id", void 0);

    _defineProperty(this, "statuteName", void 0);

    _defineProperty(this, "limitAggregate", void 0);

    _defineProperty(this, "limitAggregateSingle", Number.MAX_SAFE_INTEGER);

    _defineProperty(this, "limitAggregateJoint", Number.MAX_SAFE_INTEGER);

    _defineProperty(this, "limitPerItem", Number.MAX_SAFE_INTEGER);

    _defineProperty(this, "canApply", void 0);

    _defineProperty(this, "transformFromContext", void 0);

    _defineProperty(this, "currentAmount", 0);

    _defineProperty(this, "assetsDeclared", void 0);

    _defineProperty(this, "assetLimit", Number.MAX_SAFE_INTEGER);

    _defineProperty(this, "requiresReview", false);

    _defineProperty(this, "description", void 0);

    this.id = id;
    this.statuteName = lawName; // This will get populated with either single or joint when we transform it

    this.limitAggregate = null;
    this.limitAggregateSingle = limitAggregateSingle;
    this.limitAggregateJoint = limitAggregateJoint;
    this.limitPerItem = limitPerItem;
    this.assetLimit = assetLimit;
    this.canApply = canApply;
    this.transformFromContext = transformFromContext;
    this.currentAmount = 0;
    this.assetsDeclared = [];
    this.requiresReview = requiresReview;
    this.description = description;
  }

  _createClass(Rule, [{
    key: "transformFromCaseContext",
    // TODO: Find out what would cause rules to change
    // TODO: Transform for Homestead Act usage
    value: function transformFromCaseContext(caseObj) {
      // Transform based on common joint filing property
      this.setJointOrSingleLimitAggregate(_lodash["default"].get(caseObj, 'jointFiling', false)); // Transform if rule has context requirements
      // Ex: depedents, disability, demographics

      if (this.transformFromContext != null) this.transformFromContext(caseObj);
    }
  }, {
    key: "setJointOrSingleLimitAggregate",
    value: function setJointOrSingleLimitAggregate(isJointFiling) {
      if (isJointFiling === true) {
        this.limitAggregate = this.limitAggregateJoint;
      } else if (isJointFiling === false) {
        this.limitAggregate = this.limitAggregateSingle;
      } else {
        throw new _errors.ParameterError({
          message: 'Joint filing status not specified for filer.'
        });
      }
    }
  }, {
    key: "getAmountRemaining",
    value: function getAmountRemaining() {
      if (this.limitAggregate != null) {
        return this.limitAggregate - this.currentAmount;
      }

      throw new _errors.ParameterError({
        message: 'No limit aggregate found. Joint filing status was most likely not set.'
      });
    }
  }, {
    key: "canTakeMoreExemptions",
    value: function canTakeMoreExemptions() {
      return this.getAmountRemaining() > 0 && this.assetsDeclared.length < this.assetLimit;
    } // Checks if the asset is a TV, VCR, Radio or Computer, then checks if one already exists

  }, {
    key: "isOnlyTVVCRradioOrComputer",
    value: function isOnlyTVVCRradioOrComputer(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validTypes = [_subTypes.TV, _subTypes.VCR, _subTypes.RADIO, _subTypes.COMPUTER];

      if (validTypes.includes(subType)) {
        for (var i = 0; i < this.assetsDeclared.length; i += 1) {
          var exemption = this.assetsDeclared[i];

          if (validTypes.includes(_lodash["default"].get(exemption.asset, 'assetJSON.subType'))) {
            return false;
          }
        }

        return true;
      }

      return false;
    }
  }, {
    key: "matchesTypeSubrule",
    value: function matchesTypeSubrule(asset, type, singleLimit, jointLimit, typeOrSubtype) {
      var categoryMatcher = '';

      if (typeOrSubtype === 'TYPE') {
        categoryMatcher = 'asset.assetJSON.type';
      } else if (typeOrSubtype === 'SUBTYPE') {
        categoryMatcher = 'asset.assetJSON.subType';
      }

      var subruleLimit = 0;

      if (this.limitAggregate === this.limitAggregateSingle) {
        subruleLimit = singleLimit;
      } else if (this.limitAggregate === this.limitAggregateJoint) {
        subruleLimit = jointLimit;
      }

      var subruleCurrentValue = 0;

      for (var i = 0; i < this.assetsDeclared.length; i += 1) {
        if (_lodash["default"].get(this.assetsDeclared[i], categoryMatcher) === type) {
          var declaredValue = _lodash["default"].get(this.assetsDeclared[i].value);

          if (declaredValue != null) {
            subruleCurrentValue += declaredValue;
          }
        }
      }

      return subruleCurrentValue < subruleLimit;
    }
  }, {
    key: "isWildcard",
    value: function isWildcard() {
      return this.id === WILDCARD_ID;
    }
  }], [{
    key: "constructFromObject",
    value: function constructFromObject(rule) {
      var requiresReview = _lodash["default"].get(rule, 'requiresReview') || false;
      return new Rule(rule.id, rule.statuteName, rule.limitAggregateSingle, rule.limitAggregateJoint, null, rule.limitPerItem, rule.assetLimit, rule.canApply, rule.transformFromContext, requiresReview, rule.description);
    }
  }, {
    key: "getBaseRules",
    value: function getBaseRules(jurisdiction) {
      var baseRules = [];
      var rules = (0, _getExemptionRules["default"])(jurisdiction);
      rules.forEach(function (ruleObj) {
        return baseRules.push(Rule.constructFromObject(ruleObj));
      });
      return baseRules;
    }
  }]);

  return Rule;
}();

exports["default"] = Rule;